import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toastManagerInstance, SimpleToast } from '@exchange/libs/toasts/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'XPid',
  props: {
  altMessage: { type: String, required: false },
  text: { type: [String, Number], required: true },
},
  setup(__props) {

const props = __props;

const doOnSuccess = () => {
  toastManagerInstance.addToast({
    content: SimpleToast,
    props: {
      variant: 'default',
      title: 'fundamentals.copy.title',
      message: props.altMessage ?? 'fundamentals.copy.message.pid',
    },
  });
};

const doOnError = () => {
  toastManagerInstance.addToast({
    content: SimpleToast,
    props: {
      variant: 'failed',
      title: 'fundamentals.copy.title',
      message: 'fundamentals.copy.failed',
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ot_pid = _resolveComponent("ot-pid")!

  return (_openBlock(), _createBlock(_component_ot_pid, {
    class: "x-pid",
    text: __props.text,
    "on-success": doOnSuccess,
    "on-error": doOnError
  }, null, 8, ["text"]))
}
}

})